import React from 'react';
import LocationText from './LocationText';
import SocialNetworks from '../SocialNetworks';
import { Trans, useTranslation } from 'react-i18next';
import locationImage from '../../assets/images/landing/PNG/Source_2.png'

import './Locations.css';

const Location = () => {
  const { t } = useTranslation('location');

  return (
    <div className="locations">
      <div className="locations-image">
        <img src={locationImage} alt="" />

        <div className="locations-title">
          <h2 className="text-primary-light"> {t('location.title')} </h2>
        </div>
      </div>

      <div className="locations-text"><LocationText /></div>

      <div className="locations-footer">
        <p>
            <Trans t={t}
              i18nKey="location.note"
              components={{ bold: <b /> }}
            />
        </p>

        <SocialNetworks color="blue" />
      </div>
    </div>
  );
};

export default Location;